module.exports = __webpack_public_path__ + "static/media/errManhole.fa6eb504.png";